import type { FaireProductEntity } from "../../entity_types/product";

export const beverage_7: FaireProductEntity = {
  token: "beverage-7",
  type: "product",
  name: "Kombucha Starter Kit",
  brandName: "Craft Beverages",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/83225eb332fd099df4377b239ff2c7695db66ef76052ebe99c9a7fca7b390396.webp",
  priceDollars: 28,
  msrpDollars: 42,
  freeShipping: true,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
